export { homeScreen as default } from '~configurations';
